import React from 'react'

const Option = ({ children, selected, onClick }) => {
  return (
    <div
      className={
        selected
          ? 'step__question__option-box step__question__option-box--selected'
          : 'step__question__option-box'
      }
      onClick={onClick}
    >
      {children}
    </div>
  )
}

export { Option }
